export default __webpack_public_path__ + "static/media/johnny-mcclung-uDM99xirqI4-unsplash.a746c8b8.jpg";